import { api } from '@/api'
import { companiesStore } from '@/store/companies/companies.store'
import { myCompaniesStore } from '@/store/companies/my_companies.store'
import {
  Company,
  GetCompanyRequest,
  SendCompanyInvitationRequest,
  UpdateCompanyRequest
} from '@roolz/types/api/companies'
import { AxiosResponse } from 'axios'

const myCompanyRequestWrapper = (promise: Promise<AxiosResponse<Company, any>>) => {
  companiesStore.isMyCompanyLoading = true

  return promise
    .then(({ data }) => {
      companiesStore.addOrUpdateCompany(data)

      const myCompany = companiesStore.findCompany(data.id)
      companiesStore.myCompany = myCompany ?? null

      return data
    })
    .catch(e => {
      throw e
    })
    .finally(() => (companiesStore.isMyCompanyLoading = false))
}

class CompaniesService {
  getCompanyById({ id }: GetCompanyRequest) {
    return myCompanyRequestWrapper(api.companies.getCompanyById(id))
  }

  updateCompany(company_id: string, body: UpdateCompanyRequest) {
    return myCompanyRequestWrapper(api.companies.updateCompany(company_id, body))
  }

  getCompanyByNickname({ nickname }: { nickname: string }) {
    return api.companies.getCompanyByNickname(nickname)
      .then(({ data }) => {
        companiesStore.addOrUpdateCompany(data)
        return data
      })
  }

  async getAllCompanies({ params, body }) {
    return api.companies.getAllCompanies({
      params: {
        order_by: '-offers_count',
        ...params
      }, body
    })
      .then(({ data }) => {
        data.items.forEach((company: Company) => {
          companiesStore.addOrUpdateCompany(company)
        })

        return data
      })
  }

  async loadMyCompanies() {
    return api.companies.getOwnCompanies()
      .then(({ data }) => {
        data.forEach((company: Company) => {
          companiesStore.addOrUpdateCompany(company)
        })
        myCompaniesStore.companies = data

        return data
      })
  }

  sendCompanyInvitation(companyId: Company['id'], body: SendCompanyInvitationRequest) {
    return api.companies.sendInvitation(companyId, body)
  }
}

export const companiesService = new CompaniesService()
